import { GPTGameIcon } from 'src/EXPERIMENTAL_LIB/modules/gpt/icons';

export const PigeonEventIcon: GPTGameIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}>
    <g clip-path="url(#clip0_3026_523)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.36 5.67C17.4 5.96 15.6 6.43 13.34 6.72C11.08 7.01 9.22001 7.02 9.19001 6.74C9.16001 6.46 10.95 5.98 13.21 5.69C15.47 5.4 17.33 5.39 17.36 5.67Z"
        fill="url(#paint0_linear_3026_523)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.21 5.71C17.24 5.92 15.5 6.33 13.32 6.61C11.14 6.89 9.36 6.95 9.33 6.74C9.3 6.53 11.04 6.12 13.22 5.84C15.4 5.56 17.18 5.5 17.21 5.71Z"
        fill="url(#paint1_linear_3026_523)"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M8.35 21.48L8.63 23.28C8.63 23.28 7.84 23.51 7.76 23.69C7.68 23.86 8.66 23.98 9.42 23.93C10.18 23.89 10.32 23.85 10.47 23.69C10.62 23.53 10.63 22.03 10.63 22.03L8.34 21.49L8.35 21.48Z"
        fill="#E02E60"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.52">
        <path
          d="M8.46001 22.17C9.10001 22.39 9.89001 23.08 10.06 23.22C10.18 23.32 10.09 23.63 9.98001 23.89C10.28 23.85 10.38 23.8 10.48 23.69C10.63 23.53 10.64 22.03 10.64 22.03L8.35001 21.49L8.46001 22.18V22.17Z"
          fill="#A60AC2"
        />
      </g>
      <path
        d="M18.24 21.46L17.96 23.26C17.96 23.26 18.75 23.49 18.83 23.67C18.91 23.84 17.93 23.96 17.17 23.91C16.41 23.87 16.27 23.83 16.12 23.67C15.97 23.51 15.96 22.01 15.96 22.01L18.25 21.47L18.24 21.46Z"
        fill="#E02E60"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.52">
        <path
          d="M18.83 23.66C18.75 23.49 17.96 23.25 17.96 23.25L18.24 21.45L15.95 21.99C15.95 21.99 15.95 22.35 15.98 22.74C16.52 22.86 16.76 23.1 16.89 23.28C16.98 23.4 17.08 23.68 17.13 23.9C17.14 23.9 17.15 23.9 17.16 23.9C17.92 23.94 18.9 23.83 18.82 23.66H18.83Z"
          fill="#A60AC2"
        />
      </g>
      <path
        d="M17.71 14.37C19.1 14.37 20.23 12.74 20.23 10.73C20.23 8.72 19.1 7.09 17.71 7.09C16.32 7.09 15.19 8.72 15.19 10.73C15.19 12.74 16.32 14.37 17.71 14.37Z"
        fill="white"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.52">
        <path
          d="M17.25 13.98C18.95 13.98 20.32 12.44 20.32 10.54C20.32 8.64 18.95 7.1 17.25 7.1C15.55 7.1 14.18 8.64 14.18 10.54C14.18 12.44 15.55 13.98 17.25 13.98Z"
          fill="#4F3699"
        />
      </g>
      <path
        d="M19.48 8.56C20.01 9.4 19.99 10.22 19.43 10.41C18.87 10.59 17.99 10.06 17.46 9.23C16.93 8.39 16.95 7.57 17.51 7.38C18.07 7.2 18.95 7.73 19.48 8.56Z"
        fill="#D7D1E8"
      />
      <path
        d="M5.00999 19.04L7.94999 17.18C7.94999 17.18 5.88999 10.49 9.53999 6.61C13.18 2.73 14.83 2.44 15.12 2.69C15.41 2.94 13.36 4.88 13.36 4.88C13.36 4.88 15.24 4.08 16.01 4.27C16.77 4.46 15.72 5.1 15.72 5.1C15.72 5.1 18.66 5.31 19.42 9.79C20.18 14.27 20.71 18.37 19.71 20.22C18.53 22.41 9.82999 24.65 5.00999 19.04Z"
        fill="#6E4AFF"
      />
      <path
        d="M15.71 5.1C15.71 5.1 16.77 4.47 16 4.27C15.24 4.08 13.35 4.88 13.35 4.88C13.35 4.88 15.41 2.95 15.11 2.69C14.82 2.44 13.17 2.73 9.53 6.61C5.89 10.49 7.94 17.18 7.94 17.18C7.94 17.18 13.5 20.78 20.22 17.85C20.33 15.74 19.92 12.85 19.4 9.79C18.64 5.31 15.7 5.1 15.7 5.1H15.71Z"
        fill="url(#paint2_linear_3026_523)"
      />
      <g style={{ mixBlendMode: 'screen' }} opacity="0.16">
        <path
          d="M16.75 17.56C16.87 16.93 17.35 16.45 17.82 16.5C18.29 16.55 18.58 17.09 18.47 17.73C18.35 18.36 17.87 18.84 17.4 18.79C16.93 18.75 16.64 18.2 16.75 17.56Z"
          fill="#FFAD17"
        />
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.52">
        <path
          d="M16.27 11.39C16.23 12.03 16.49 13.08 17.21 13.24C17.93 13.4 18.43 11.98 18.43 11.98L16.27 11.4V11.39Z"
          fill="#2E4BA3"
        />
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.52">
        <path
          d="M15.07 2.63C14.23 2.86 13.25 4.1 13.36 4.88C14.34 3.9 15.33 2.92 15.07 2.63Z"
          fill="#2E4BA3"
        />
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.52">
        <path
          d="M11.99 14.6C13.87 14.6 15.4 12.92 15.4 10.85C15.4 8.78 13.87 7.1 11.99 7.1C11.58 7.1 11.19 7.18 10.83 7.32C9.6 9.2 9.37 11.49 9.45 13.35C10.07 14.11 10.98 14.6 11.99 14.6Z"
          fill="#2E4BA3"
        />
      </g>
      <path
        d="M7.95 17.18C7.95 17.18 8.81 19.14 14.23 19.6C17.2 19.85 19.09 19.04 20.21 18.19C20.23 17.97 20.24 17.74 20.25 17.49C16.06 19.84 9.69 18.15 7.95 17.18Z"
        fill="#E2EED6"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.52">
        <path
          d="M19.41 9.79C18.65 5.31 15.71 5.1 15.71 5.1C15.71 5.1 16.69 4.51 16.08 4.3C15.6 4.86 14.39 5.15 14.39 5.15C17.93 6.58 20.69 17.48 17.56 20.19C15.8 21.71 12.51 21.76 9.77 21.24C10.07 20.85 10.35 20.33 10.4 19.83L8.54 20.96C7.27 20.62 6.23 20.18 5.67 19.74C6.36 20.41 7.12 20.93 7.91 21.35C7.91 21.35 7.92 21.35 7.95 21.37C8.32 21.56 8.7 21.73 9.09 21.87C9.09 21.87 9.11 21.87 9.12 21.88C13.67 23.55 18.82 21.88 19.7 20.22C20.69 18.37 20.17 14.27 19.41 9.79Z"
          fill="#2E4BA3"
        />
      </g>
      <path d="M15.71 5.1C14.88 5.04 13.99 5.2 13.99 5.2L15.71 5.1Z" fill="#36A5EB" />
      <path
        d="M15.7 5.18C15.63 5.18 15.56 5.18 15.49 5.18C15.42 5.18 15.35 5.18 15.28 5.18C15.14 5.18 15 5.18 14.86 5.19C14.72 5.19 14.58 5.2 14.43 5.21C14.29 5.21 14.14 5.23 14 5.24C14 5.24 13.95 5.23 13.95 5.21C13.95 5.19 13.96 5.18 13.98 5.18C14.12 5.14 14.26 5.11 14.4 5.09C14.54 5.06 14.69 5.05 14.83 5.03C15.12 5 15.42 5 15.72 5.03C15.78 5.03 15.82 5.08 15.81 5.12C15.81 5.16 15.76 5.19 15.7 5.19V5.18Z"
        fill="#002657"
      />
      <path
        d="M11.99 14.09C13.87 14.09 15.4 12.52 15.4 10.59C15.4 8.66 13.87 7.09 11.99 7.09C10.11 7.09 8.58 8.66 8.58 10.59C8.58 12.52 10.11 14.09 11.99 14.09Z"
        fill="url(#paint3_linear_3026_523)"
      />
      <path
        d="M20.32 10.54C20.32 11.06 20.21 11.56 20.03 12.01C20.52 11.57 20.82 10.95 20.82 10.27C20.82 9.34 20.26 8.53 19.43 8.13C19.98 8.75 20.32 9.61 20.32 10.55V10.54Z"
        fill="#002657"
      />
      <path
        d="M11.16 13.01C12.58 13.01 13.74 11.93 13.74 10.59C13.74 9.25 12.59 8.17 11.16 8.17C9.73 8.17 8.58 9.25 8.58 10.59C8.58 11.93 9.73 13.01 11.16 13.01Z"
        fill="#002657"
      />
      <g style={{ mixBlendMode: 'soft-light' }} opacity="0.24">
        <path
          d="M11.57 8.97C11.71 9.23 11.57 9.5 11.26 9.59C10.95 9.68 10.58 9.54 10.44 9.29C10.3 9.03 10.44 8.76 10.75 8.67C11.06 8.58 11.43 8.72 11.57 8.97Z"
          fill="white"
        />
      </g>
      <g style={{ mixBlendMode: 'soft-light' }} opacity="0.24">
        <path
          d="M11.33 12.82C12.17 12.58 12.46 11.7 12 10.85C11.53 10 10.48 9.5 9.64 9.74C8.8 9.98 8.51 10.86 8.97 11.71C9.44 12.56 10.49 13.06 11.33 12.82Z"
          fill="white"
        />
      </g>
      <path
        d="M13.61 10.4C14.34 10.19 14.78 9.75 14.6 9.42C14.42 9.08 13.67 8.98 12.94 9.19C12.21 9.4 11.77 9.84 11.95 10.17C12.13 10.51 12.88 10.61 13.61 10.4Z"
        fill="white"
      />
      <path
        d="M7.29001 19.52C6.93001 19.3 5.99001 19.01 5.81001 19.52C4.74001 21.88 7.41001 22.63 9.96001 20.28C10.23 20.03 10.41 19.83 10.53 19.67L7.30001 19.52H7.29001Z"
        fill="#8F40FF"
      />
      <g style={{ mixBlendMode: 'screen' }} opacity="0.24">
        <path
          d="M9.2 19.65C8.92 19.79 8.79 20.01 8.91 20.13C9.03 20.25 9.36 20.23 9.64 20.09C9.92 19.95 10.05 19.73 9.93 19.61C9.81 19.49 9.48 19.51 9.2 19.65Z"
          fill="#B3FF75"
        />
      </g>
      <path
        d="M5.81 19.52C5.33 20.58 5.61 21.32 6.28 21.59C6.35 21.62 6.43 21.64 6.51 21.66C5.17 21.1 6.9 19.34 6.9 19.34C6.48 19.2 5.94 19.15 5.81 19.52Z"
        fill="#A667FF"
      />
      <path
        d="M6.09 19.32C6.09 19.38 6.13 19.45 6.18 19.51C6.23 19.58 6.29 19.64 6.36 19.7C6.43 19.76 6.5 19.82 6.58 19.88C6.66 19.94 6.74 19.99 6.83 20.04C6.83 20.04 6.85 20.07 6.83 20.08C6.83 20.09 6.8 20.09 6.79 20.08C6.67 20.05 6.57 20 6.48 19.95C6.38 19.9 6.3 19.84 6.21 19.78C6.13 19.72 6.05 19.65 5.99 19.57C5.93 19.49 5.87 19.4 5.88 19.3C5.88 19.26 5.93 19.22 5.99 19.22C6.05 19.22 6.09 19.25 6.09 19.29V19.32Z"
        fill="#002657"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.52">
        <path
          d="M10.25 19.99C9.08 20.88 5.59 20.99 5.86 19.43C5.84 19.46 5.83 19.49 5.82 19.52C4.75 21.88 7.42 22.63 9.97 20.28C10.08 20.18 10.18 20.08 10.26 19.99H10.25Z"
          fill="#2E4BA3"
        />
      </g>
      <path
        d="M5.94 19.49C5.93 19.6 5.91 19.72 5.92 19.83C5.92 19.94 5.95 20.06 5.99 20.17C6.03 20.28 6.08 20.39 6.14 20.5C6.2 20.61 6.27 20.71 6.35 20.81C6.35 20.81 6.35 20.86 6.33 20.87C6.31 20.87 6.28 20.87 6.26 20.87C6.14 20.78 6.04 20.68 5.96 20.57C5.88 20.46 5.81 20.34 5.77 20.22C5.72 20.1 5.69 19.98 5.69 19.85C5.68 19.72 5.69 19.6 5.72 19.47C5.72 19.43 5.79 19.4 5.85 19.41C5.91 19.41 5.95 19.45 5.94 19.49Z"
        fill="#002657"
      />
      <path d="M8.86 23.49C8.63 23.69 8.63 23.92 8.63 23.92L8.86 23.49Z" fill="#FF9900" />
      <path d="M17.73 23.47C17.96 23.67 17.96 23.9 17.96 23.9L17.73 23.47Z" fill="#FF9900" />
      <path
        d="M5.01 19.04C5.01 19.04 4.75 17.23 4.87 17C4.99 16.77 6.3 18.01 5.01 19.04Z"
        fill="#9B54FF"
      />
      <path
        d="M5.01 19.04C3.8 18.68 2.95 17.91 3.24 16.78C3.53 15.65 4.77 18.31 5.01 19.04Z"
        fill="#9B54FF"
      />
      <path
        d="M16.43 11.47C16.06 11.33 16.34 9.33 17.42 9.35C18.5 9.37 18.46 11.38 17.97 11.52C17.48 11.66 16.43 11.47 16.43 11.47Z"
        fill="#E2EED6"
      />
      <path
        d="M16.43 11.47C16.43 10.04 17.99 9.19 18.68 11.49C17.61 14.06 16.67 12.79 16.43 11.47Z"
        fill="url(#paint4_linear_3026_523)"
      />
      <g style={{ mixBlendMode: 'soft-light' }} opacity="0.7">
        <path
          d="M17.61 10.78C17.43 11.01 17.13 11.13 16.95 11.06C16.77 10.98 16.77 10.74 16.95 10.51C17.13 10.28 17.43 10.16 17.61 10.23C17.79 10.31 17.79 10.55 17.61 10.78Z"
          fill="white"
        />
      </g>
      <path
        d="M17.25 11.51C17.48 11.43 17.73 11.4 17.98 11.39C18.1 11.39 18.23 11.39 18.35 11.41C18.47 11.42 18.59 11.44 18.72 11.48C18.78 11.5 18.8 11.54 18.78 11.58C18.76 11.61 18.71 11.63 18.67 11.63H18.66C18.56 11.62 18.44 11.61 18.33 11.6C18.22 11.6 18.1 11.59 17.99 11.58C17.88 11.58 17.76 11.58 17.65 11.58C17.54 11.58 17.43 11.6 17.31 11.61C17.31 11.61 17.22 11.59 17.22 11.56C17.22 11.53 17.23 11.51 17.26 11.5L17.25 11.51Z"
        fill="#002657"
      />
      <path
        d="M17.44 13.05C17.44 13.05 17.41 13.05 17.4 13.05C16.81 13.02 16.45 12.18 16.32 11.48C16.32 11.48 16.32 11.48 16.32 11.47C16.32 10.69 16.79 10.04 17.39 9.99C17.67 9.97 18.37 10.07 18.79 11.47C18.79 11.48 18.79 11.5 18.79 11.51C18.36 12.55 17.92 13.05 17.44 13.05ZM16.54 11.47C16.69 12.28 17.06 12.88 17.42 12.9C17.58 12.9 18.03 12.79 18.57 11.49C18.31 10.62 17.88 10.12 17.42 10.15C17 10.18 16.55 10.7 16.55 11.47H16.54Z"
        fill="#002657"
      />
      <path
        opacity="0.3"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.5 6.54C9.5 6.54 9.29 6.82 9.36 6.81C9.43 6.8 10.53 6.3 13.52 5.9C14.88 5.72 16.84 5.69 17.01 5.7C17.18 5.71 17.34 5.61 16.93 5.55C16.52 5.49 13.5 5.57 12.66 5.71C11.82 5.85 9.67 6.34 9.5 6.54Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.19 2.39C9.19 2.39 9.36 1.51 9.53 1.19C9.53 1.19 11.37 1.52 11.84 2.63C11.84 2.63 11.5 4.93 10.5 4.53C9.49 4.13 9.19 2.4 9.19 2.4V2.39Z"
        fill="url(#paint5_linear_3026_523)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.17 1.47C16.17 1.47 15.78 0.659999 15.53 0.399999C15.53 0.399999 13.84 1.19 13.67 2.38C13.67 2.38 14.59 4.52 15.46 3.87C16.33 3.22 16.17 1.47 16.17 1.47Z"
        fill="url(#paint6_linear_3026_523)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.61 0.0599995C17.61 0.0599995 16.27 0.23 15.54 1.78C15.74 1.92 15.89 2.16 15.93 2.46C16 2.96 15.7 3.41 15.27 3.47C14.84 3.53 14.44 3.17 14.38 2.67C14.34 2.34 14.45 2.03 14.66 1.84C14.24 1.3 13.54 0.619999 12.48 0.149999C11.57 0.88 11.07 1.72 10.8 2.35C11.04 2.48 11.23 2.75 11.27 3.07C11.34 3.57 11.04 4.02 10.61 4.08C10.18 4.14 9.78 3.78 9.72 3.28C9.68 2.98 9.77 2.7 9.94 2.52C8.83 1.22 7.5 1.4 7.5 1.4C9.33 3.67 9.31 6.63 9.31 6.63L11.72 5.83L15.16 5.39L17.19 5.6C17.19 5.6 16.42 2.75 17.6 0.0799995L17.61 0.0599995Z"
        fill="url(#paint7_linear_3026_523)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.68 4.06C10.68 4.06 10.64 4.06 10.62 4.07C10.19 4.13 9.78999 3.77 9.72999 3.27C9.68999 2.97 9.77999 2.7 9.94999 2.51C9.04999 1.45 7.96999 1.35 7.50999 1.39C7.50999 1.39 7.62999 1.38 7.62999 1.37C7.62999 1.37 8.95999 1.19 10.07 2.49C9.89999 2.68 9.81999 2.96 9.84999 3.25C9.90999 3.73 10.28 4.07 10.68 4.06Z"
        fill="url(#paint8_linear_3026_523)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.23 3.47C15.23 3.47 15.27 3.47 15.29 3.47C15.72 3.41 16.01 2.96 15.95 2.46C15.91 2.16 15.76 1.92 15.55 1.78C16.15 0.529999 17.16 0.149999 17.62 0.0699995L17.5 0.0899995C17.5 0.0899995 16.17 0.259999 15.43 1.8C15.64 1.94 15.8 2.19 15.83 2.48C15.89 2.96 15.63 3.39 15.24 3.48L15.23 3.47Z"
        fill="url(#paint9_linear_3026_523)"
      />
      <g filter="url(#filter0_d_3026_523)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.33 5.44C17.29 5.15 15.43 5.16 13.18 5.46C10.93 5.76 9.12 6.23 9.16 6.51C9.16 6.51 9.18 6.7 9.19 6.74C9.21 6.59 9.55 6.47 9.55 6.47C10.21 6.21 11.55 5.91 13.14 5.7C14.73 5.49 16.17 5.4 16.92 5.5C16.92 5.5 17.34 5.53 17.37 5.67L17.34 5.44H17.33Z"
          fill="url(#paint10_linear_3026_523)"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.36 5.67C17.39 5.89 17.58 5.17 13.28 5.77C9.61999 6.28 9.19999 6.83 9.18999 6.74C9.15999 6.45 10.95 5.98 13.21 5.69C15.47 5.4 17.33 5.39 17.36 5.67Z"
        fill="url(#paint11_linear_3026_523)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_3026_523"
        x="-5.84065"
        y="-4.77139"
        width="28.2106"
        height="21.5114"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-5" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.847059 0 0 0 0 0.54902 0 0 0 0 0.207843 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3026_523" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3026_523"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3026_523"
        x1="9.18566"
        y1="6.73467"
        x2="17.3563"
        y2="5.66769"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F9CE3E" />
        <stop offset="0.12" stop-color="#E5A11D" />
        <stop offset="0.2" stop-color="#D98508" />
        <stop offset="0.25" stop-color="#D57B01" />
        <stop offset="0.48" stop-color="#F2BE34" />
        <stop offset="0.69" stop-color="#FCD745" />
        <stop offset="1" stop-color="#D37900" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3026_523"
        x1="9.32707"
        y1="6.73637"
        x2="17.2002"
        y2="5.70824"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F9CE3E" />
        <stop offset="0.12" stop-color="#E5A11D" />
        <stop offset="0.2" stop-color="#D98508" />
        <stop offset="0.25" stop-color="#D57B01" />
        <stop offset="0.48" stop-color="#F2BE34" />
        <stop offset="0.69" stop-color="#FCD745" />
        <stop offset="1" stop-color="#D37900" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3026_523"
        x1="13.81"
        y1="1.51"
        x2="13.81"
        y2="17.37"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#7CBDFF" />
        <stop offset="1" stop-color="#6A00FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3026_523"
        x1="12.59"
        y1="14.49"
        x2="11.7"
        y2="8.73"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#A396CA" />
        <stop offset="1" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3026_523"
        x1="16.43"
        y1="11.52"
        x2="18.68"
        y2="11.52"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFBC00" />
        <stop offset="1" stop-color="#FF6700" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3026_523"
        x1="9.27175"
        y1="2.99201"
        x2="11.8399"
        y2="2.65664"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#EAAE29" />
        <stop offset="1" stop-color="#D17601" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_3026_523"
        x1="16.3916"
        y1="1.44707"
        x2="13.7353"
        y2="3.34703"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#EAAE29" />
        <stop offset="1" stop-color="#D17601" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_3026_523"
        x1="7.8112"
        y1="3.77775"
        x2="17.9154"
        y2="2.45827"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#FADA40" />
        <stop offset="0.03" stop-color="#F1C734" />
        <stop offset="0.12" stop-color="#DD9A18" />
        <stop offset="0.19" stop-color="#D07E06" />
        <stop offset="0.23" stop-color="#CC7400" />
        <stop offset="0.29" stop-color="#DC7C00" />
        <stop offset="0.34" stop-color="#EC8500" />
        <stop offset="0.39" stop-color="#EE950C" />
        <stop offset="0.47" stop-color="#F5C12D" />
        <stop offset="0.48" stop-color="#F7CB34" />
        <stop offset="0.71" stop-color="#FFFBE2" />
        <stop offset="0.73" stop-color="#FDF3C5" />
        <stop offset="0.78" stop-color="#FBE699" />
        <stop offset="0.82" stop-color="#F9DC74" />
        <stop offset="0.87" stop-color="#F8D558" />
        <stop offset="0.91" stop-color="#F7CF44" />
        <stop offset="0.96" stop-color="#F7CC38" />
        <stop offset="1" stop-color="#F7CB34" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_3026_523"
        x1="8.22639"
        y1="1.01069"
        x2="10.2868"
        y2="4.4327"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#FCE3A1" />
        <stop offset="0.07" stop-color="#FCDF8B" />
        <stop offset="0.18" stop-color="#FCD96F" />
        <stop offset="0.25" stop-color="#FDD865" />
        <stop offset="0.48" stop-color="#FDE19B" />
        <stop offset="0.83" stop-color="#C97902" />
        <stop offset="1" stop-color="#F7CB34" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_3026_523"
        x1="16.817"
        y1="-0.107567"
        x2="15.7043"
        y2="3.7288"
        gradientUnits="userSpaceOnUse">
        <stop offset="0.24" stop-color="#FCE3A1" />
        <stop offset="0.28" stop-color="#FCDF8B" />
        <stop offset="0.34" stop-color="#FCD96F" />
        <stop offset="0.38" stop-color="#FDD865" />
        <stop offset="0.55" stop-color="#FFEBA8" />
        <stop offset="0.72" stop-color="#C97902" />
        <stop offset="1" stop-color="#F7CB34" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_3026_523"
        x1="9.13645"
        y1="6.35787"
        x2="17.3071"
        y2="5.29089"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F9D83F" />
        <stop offset="0.11" stop-color="#F2AB1D" />
        <stop offset="0.2" stop-color="#ED8F07" />
        <stop offset="0.25" stop-color="#EC8500" />
        <stop offset="0.48" stop-color="#F7CB34" />
        <stop offset="0.69" stop-color="#FCF2BD" />
        <stop offset="1" stop-color="#F7CB34" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_3026_523"
        x1="9.15457"
        y1="6.49669"
        x2="17.3252"
        y2="5.42971"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F9CE3E" />
        <stop offset="0.12" stop-color="#E5A11D" />
        <stop offset="0.2" stop-color="#D98508" />
        <stop offset="0.25" stop-color="#D57B01" />
        <stop offset="0.48" stop-color="#F2BE34" />
        <stop offset="0.69" stop-color="#FCD745" />
        <stop offset="1" stop-color="#D37900" />
      </linearGradient>
      <clipPath id="clip0_3026_523">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
